import React from 'react'
import PropTypes from "prop-types";

function IconLabel(props) {
  let icon = props.icon;
  if (props.isCheckbox) {
    icon = props.isChecked ? "fz-check has-text-success" : "fz-times has-text-danger";
  }
  return (
    <div className="info-card-wrapper">
      <span
        className={"icon fz has-padding-right-10 solid " + icon}></span>
      <span>{props.label}</span>
    </div>
  )
}

IconLabel.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  isCheckbox: PropTypes.bool,
  isChecked: PropTypes.bool,
}

export default IconLabel;
